import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e332692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer-display" }
const _hoisted_2 = { class: "timer-display__icon" }
const _hoisted_3 = { class: "timer-display__time" }

import { computed } from 'vue';
import { useFormatSecondsToNow } from '@/composables/formatTime';

interface Props {
  timeInSeconds: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TimerDisplay',
  props: {
    timeInSeconds: { default: 0 }
  },
  setup(__props: any) {

const props = __props;



const timer = computed(() => useFormatSecondsToNow({ seconds: props.timeInSeconds }));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_icon, {
        name: "schedule",
        size: "20px"
      })
    ]),
    _createElementVNode("strong", _hoisted_3, _toDisplayString(timer.value), 1)
  ]))
}
}

})